module.exports = __webpack_public_path__ + "img/38.f71cd71.jpg";